module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8wScw"))).then(() => parcelRequire('8rm4T'));